/**
 * A utility function to deeply compare two values for equality.
 * It handles primitive types, arrays, and objects.
 *
 * @param {any} a - The first value to compare.
 * @param {any} b - The second value to compare.
 * @returns {boolean} - Returns true if the values are equal, false otherwise.
 */
export function isEqual(a: any, b: any): boolean {
  if (a === b) return true
  if (a === null || b === null) return a === b
  if (typeof a !== typeof b) return false

  // If one is array and the other is not, return false
  if (Array.isArray(a) !== Array.isArray(b)) return false

  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false
    return a.every((item, i) => isEqual(item, b[i]))
  }

  if (typeof a === 'object' && typeof b === 'object') {
    const aKeys = Object.keys(a)
    const bKeys = Object.keys(b)
    if (aKeys.length !== bKeys.length) return false
    return aKeys.every(
      key =>
        Object.prototype.hasOwnProperty.call(b, key) && isEqual(a[key], b[key])
    )
  }

  return false
}
